import { FC, useCallback, useEffect, useState } from 'react';

import Slide from 'app/components/v2/animations/Slide';
import Notification from 'app/components/v2/components/Notification';
import { Alert } from 'app/state/AlertsContext/Provider';

// Local Typings
interface AlertProps {
  alert: Alert;
}
interface Props extends AlertProps {
  onRemove: (index: number) => void;
}

export const notificationMarginRight = 20;

// Local Variables
const animationDurationInMS = 300;

// Component Definition
const NotificationUI: FC<Props> = ({
  alert,
  onRemove,
}) => {
  const [isIn, setIsIn] = useState(false);

  const {
    onClickClose,
    onTimeoutClose,
    shouldAutoHide = true,
  } = alert;

  const handleRemoveAlert = useCallback(() => {
    setIsIn(false);
    setTimeout(() => {
      onRemove(alert.timestamp);
    },
    animationDurationInMS);
  },
  [alert.timestamp, onRemove]);

  const handleClickClose = useCallback(() => {
    handleRemoveAlert();
    onClickClose?.();
  },
  [handleRemoveAlert, onClickClose]);

  useEffect(() => {
    if (isIn && shouldAutoHide) {
      setTimeout(() => {
        handleRemoveAlert();
        onTimeoutClose?.();
      },
      5000);
    }
  },
  [handleRemoveAlert, isIn, onTimeoutClose, shouldAutoHide]);

  useEffect(() => {
    setIsIn(true);
  },
  []);

  return (
    <Slide
      endX={0}
      isIn={isIn}
      position="relative"
      startX={`calc(100% + ${notificationMarginRight}px)`}
      transitionSpeedInMs={animationDurationInMS}
    >
      <Notification
        message={alert.message ?? ''}
        onClose={handleClickClose}
        secondaryElement={alert.secondaryContent}
        severity={alert.alertLevel}
        title={alert.title}
        variant="toast"
      />
    </Slide>
  );
};

export default NotificationUI;
